import { TableV2 } from '@anytag/shared-atoms';
import { TableData } from '@anytag/shared-types';
import { useTableMaxHeight } from '@anytag/shared-hooks';
import { TrendingInfluencersTabType } from '../TrendingInfluencersFilter/schemaTypes';
import { useTrendingInfluencersTable } from './hooks';
import { TrendingInfluencerProfileType } from './types';

export interface TrendingInfluencersListProps extends TableData<TrendingInfluencerProfileType> {
  tab: TrendingInfluencersTabType;
}

export const TrendingInfluencersList = ({ tab, loading, data = [] }: TrendingInfluencersListProps) => {
  const { columns } = useTrendingInfluencersTable({ tab });
  const { offsetRef, defaultTableMaxHeight } = useTableMaxHeight();

  return (
    <TableV2
      data={data}
      loading={loading}
      columns={columns}
      noTopBorderRadius
      stickyHeader
      hasBorder
      ref={offsetRef}
      maxHeight={defaultTableMaxHeight}
    />
  );
};

export { type TrendingInfluencerProfileType } from './types';
